import { parseCookies } from 'nookies'

export const getGuruToken = (): string | null => {
  const { userSession } = parseCookies()
  if (!userSession) return null

  const { guruToken } = JSON.parse(userSession)
  return guruToken ?? null
}
